import React from 'react'
import styled from "styled-components"
import Daniel from './Images/Daniel-Avery.jpeg'
import Teni from './Images/Teni.jpeg'
import Valentine from './Images/Valentine.jpeg'
import Jordan from './Images/Jordan.jpeg'
import Ayo from './Images/Ayotunde.jpeg'
import Bobby from './Images/Bobby.jpeg'
import Farouk from './Images/Farouk.jpeg'
import Julius from './Images/Julius.jpeg'
import Gori from './Images/Gori.jpeg' 
import Sodiq from './Images/Odunuga Sodiq.jpeg'
import Ibe from './Images/Ibe.jpeg'

function Astro() {

  return (
    <div>
        <h1>TEAM ASTRO</h1>
        <h3>OWNER: Moore</h3>
        <br/>
        <Div>
            <div><Img src={Daniel}/> Daniel Avery - 6'4, SF</div><br/>
            <div><Img src={Farouk}/> Farouk - </div><br/>
            <div><Img src={Teni}/> Odutolu Teni</div><br/>
            <div><Img src={Valentine}/> Agugbuem Valentine</div><br/>
            <div><Img src={Jordan}/> Jordan Ayorinde </div><br/>
            <div><Img src={Ayo}/> Ayotunde Ajayi</div><br/>
            <div><Img src={Bobby}/> Bobby Deniro</div><br/>
            <div><Img src={Farouk}/> Lawal Farouk</div><br/>
            <div><Img src={Julius}/> Nwabueze Julius</div><br/>
            <div><Img src=""/> Naomi Ogbechie</div><br/>
            <div><Img src={Gori}/> Adeloye Goriola</div><br/>
            <div><Img src={Ibe}/> Ibe</div><br/>
            <div><Img src={Sodiq}/> Adebayo Sodiq</div><br/>
            <div><Img src=""/> Sheffy</div><br/>
        </Div>

        
    </div>
  )
}


export default Astro

const Img = styled.img`
height: 300px;
width: 300px;
@media screen and (max-width: 750px) {
  height: 150px;
  width: 150px;
}
`

const Div = styled.div`
font-size: 20px;
font-weight: bold;
`